'use strict';

require('./performance-review-intro.scss');

module.exports = {
  template: require('./performance-review-intro.html'),
  controller: require('./performance-review-intro.controller'),
  controllerAs: 'vm',

  bindings: {
    data: '<'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/performance-review/performance-review-intro/index.js
 ** module id = 304
 ** module chunks = 0
 **/